<template>
  <div class="presence-tracker">
    <header>
      <h1>¿Quién está en casa?</h1>
      <p class="subtitle">Comprueba quién está actualmente en casa</p>
    </header>

    <div class="people-list">
      <PersonCard
        v-for="(person, index) in store.users"
        :key="index"
        :person="person"
        @update:status="updatePersonStatus"
      />
    </div>
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import PersonCard from "@/components/PersonCard.vue";

import { useAuth } from "@/store/auth";

const store = useAuth();

// Load data from localStorage if available
onMounted(() => {
  store.getUsers();
});

// Update a person's status
const updatePersonStatus = updatedPerson => {
  store.updateStatus(updatedPerson.is_home);
};
1;
</script>

<style>
.presence-tracker {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
  color: #333;
}

header {
  text-align: center;
  margin-bottom: 30px;
}

h1 {
  margin: 0;
  color: #2c3e50;
  font-size: 2rem;
}

.subtitle {
  color: #7f8c8d;
  margin-top: 5px;
}

.people-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.add-person {
  margin-top: 30px;
  display: flex;
  gap: 10px;
}

.add-person input {
  flex: 1;
  padding: 10px 15px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 1rem;
}

.add-person button {
  background-color: #42b983;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 10px 20px;
  cursor: pointer;
  font-weight: bold;
}

.add-person button:hover {
  background-color: #3aa876;
}
</style>
